import { register } from "@cozumel-reef-maps/web_general/js/api/api_members.js";
import { hidde_preloader } from "@cozumel-reef-maps/web_general/js/ui/preloader.js";


export default function initRegister_Members(container) {
    console.log("Se ha cargado el módulo de Login.");
    
  hidde_preloader();
  window.register = register;
  
   
}









